/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderComboGroupSchema } from "./repeatMobileOrderComboGroupSchema.ts";

export const repeatMobileOrderComboSchema = z.object({
	id: z.uuid().nullish(),
	amount: z.int(),
	groups: z.array(repeatMobileOrderComboGroupSchema).nullish(),
	available: z.boolean(),
	reason: z.string().nullish(),
	internal_reason: z.string().nullish(),
});
